/* External */
import { useMemo, useState, useEffect } from 'react';

/* Ott-common */
import {
  MILLISECONDS_IN_A_SECOND,
} from '@dtvgo/constants';

/* Utils */
import { useWelcomePageData } from '../../../../providers/ConfigProvider/ConfigProvider';
import { LAST_IMAGE_DISPLAY_TIME_SECONDS } from './constants';

export function useImages() {
  const { images, displayTime } = useWelcomePageData() || {};
  const [currentImagePosition, setCurrentImagePosition] = useState(0);

  const currentImages = useMemo(() => (
    images.map((item, index) => (
      {
        ...item,
        show: index === currentImagePosition,
        image: item.image,
      }
    ))
  ), [currentImagePosition, images]);

  useEffect(() => {
    if (images.length > 1) {
      const nextImagePosition = currentImagePosition + 1;
      const isLastImage = nextImagePosition === images.length;
      const delay = (
        isLastImage ? LAST_IMAGE_DISPLAY_TIME_SECONDS : displayTime) * MILLISECONDS_IN_A_SECOND;

      const timeOut = setTimeout(() => setCurrentImagePosition(
        isLastImage ? 0 : nextImagePosition,
      ), delay);
      return () => timeOut && clearTimeout(timeOut);
    }

    return () => {};
  }, [currentImagePosition, displayTime, images.length]);

  return {
    images: currentImages,
    showDots: images.length > 1,
    length: images.length,
    position: currentImagePosition,
  };
}
